import { saveAs } from "file-saver";
import { useState } from "react";
import { Icon, Typography, Modal, Button, Skeleton } from "@/components/atoms";
import { getAssetName } from "@/components/organisms/Marketing/helpers";
import { useOperator } from "@/hooks";
import { useGetAppLinksQuery, useGetDeepLinksQuery } from "@/redux/apis/config/linksAndDocuments";

interface InviteClientsModalProps {
  open: boolean;
  onClose: () => void;
}

export const InviteClientsModal = ({ open, onClose }: InviteClientsModalProps) => {
  const { images } = useOperator();
  const { isFetching: isFetchingAppLinks } = useGetAppLinksQuery();
  const { isFetching: isFetchingDeepLinks } = useGetDeepLinksQuery();
  const isFetching = isFetchingAppLinks || isFetchingDeepLinks;

  const [showQRModal, setShowQRModal] = useState(false);

  const qrUrl = images?.qr;
  const qrTransparentUrl = images?.qrTransparent;
  const qrUrlName = getAssetName(qrUrl);
  const qrTransparentUrlName = getAssetName(qrTransparentUrl);

  const renderHeader = () => (
    <div className="sm:flex sm:items-start">
      <div className="mt-3 w-full text-center sm:mt-0 sm:text-left">
        <div className="flex flex-row items-center">
          <Typography variant="title" className="flex-1">
            Invite Clients
          </Typography>
          <Icon name="close" isCustom className="flex cursor-pointer justify-end" onClick={onClose} />
        </div>
      </div>
    </div>
  );

  const renderQRCodeSection = () => {
    return (
      <div className="flex flex-col gap-4 lg:flex-row">
        <div className="flex justify-center lg:justify-start">
          {qrUrl && (
            <div className="flex h-[225px] w-[225px] items-center justify-center rounded-lg bg-white p-[22.5px] shadow-lg">
              <img src={qrUrl} alt="Client QR Code" className="h-[180px] w-[180px] object-contain" />
            </div>
          )}
        </div>
        <div className="flex flex-col gap-2">
          <Typography variant="paragraph" className="font-semibold">
            Get the QR code for download or send it manually via email
          </Typography>
          <Button
            variant="secondary"
            className="w-fit hover:bg-info-light"
            size="sm"
            onClick={() => {
              onClose();
              setShowQRModal(true);
            }}
            disabled={!qrUrl && !qrTransparentUrl}
          >
            Download QR Code
          </Button>
        </div>
      </div>
    );
  };

  // TODO: Implement email invitation API
  // const renderEmailSection = () => (
  //   <div className="flex flex-col gap-y-2">
  //     <Typography variant="paragraph" className="font-medium">
  //       Email(s)
  //     </Typography>
  //     <MultiEmailInput emails={emails} onChange={setEmails} placeholder="Enter Email(s)" />
  //     <Typography variant="paragraph" className="text-neutral-dark-gray">
  //       You can enter multiple email addresses separated by commas
  //     </Typography>
  //   </div>
  // );

  // const handleInvite = async () => {
  //   if (emails.length === 0) {
  //     addToast("info", "Please enter at least one email address");
  //     return;
  //   }

  //   setIsSubmitting(true);
  //   try {
  //     // await inviteClients({ emails, appLink: appDownload?.document.link });
  //     addToast("success", `Invitation sent to ${emails.length} client(s)`);
  //     setEmails([]);
  //     onClose();
  //   } catch (error) {
  //     addToast("danger", "Failed to send invitations. Please try again.");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  // const renderButtons = () => (
  //   <div className="mt-4">
  //     <Button size="lg" variant="primary" onClick={handleInvite} disabled={emails.length === 0 || isSubmitting} className="w-full">
  //       {isSubmitting ? "Sending..." : "Invite Client(s)"}
  //     </Button>
  //   </div>
  // );

  return (
    <>
      <Modal open={open} onClose={onClose} className="w-[85vw] md:w-[550px] lg:w-[550px]">
        {renderHeader()}
        <div className="flex flex-col gap-y-6 py-4">
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Share the client registration link to invite them. They need to complete the registration to join the system.
          </Typography>

          {isFetching ? <Skeleton /> : renderQRCodeSection()}
          {/* {renderEmailSection()} */}
        </div>
        {/* {renderButtons()} */}
      </Modal>

      <Modal
        open={showQRModal}
        onClose={() => setShowQRModal(false)}
        className="w-[85vw] md:w-[550px] lg:w-[550px]"
        title="Download QR Code"
        description="Choose a QR code style: Opt for a transparent background, ideal for emails, cards, etc., or select a white background, perfect for mobile phones."
      >
        <div className="mt-5 flex w-full flex-col gap-x-4 gap-y-2 lg:flex-row">
          <Button
            variant="primary"
            size="md"
            disabled={!qrTransparentUrl}
            onClick={() => {
              if (qrTransparentUrl) {
                saveAs(qrTransparentUrl, qrTransparentUrlName);
                setShowQRModal(false);
              }
            }}
          >
            Download with Transparent BG
          </Button>
          <Button
            variant="secondary"
            size="md"
            disabled={!qrUrl}
            onClick={() => {
              if (qrUrl) {
                saveAs(qrUrl, qrUrlName);
                setShowQRModal(false);
              }
            }}
          >
            Download with White BG
          </Button>
        </div>
      </Modal>
    </>
  );
};
